import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import ClockLoader from 'shared/components/ClockLoader';

const UnassignTenantFromService = ({
  open,
  onClose,
  onConfirm,
  submitting = false,
  serviceName = '',
}) => {
  return (
    <Dialog open={open} onClose={() => !submitting && onClose()} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>Unlink service?</DialogTitle>
      <DialogContent>
        <Typography variant="body2">Do you want to unlink the service?</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={submitting}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="warning"
          onClick={onConfirm}
          disabled={submitting}
        >
          {submitting ? <ClockLoader inline size={22} /> : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnassignTenantFromService;
